import { Expose, Type } from 'class-transformer';

import { SnBaseLayer } from './base-layer';
import { SnLayerMeta } from './layer-meta';
import { SnLayerType } from './layer-type';

export class GeoJSONLayerMeta extends SnLayerMeta {}

export class SnGeoJSONLayer extends SnBaseLayer {
  @Expose({ name: 'externalUrl' })
  public externalUrl: string;

  @Expose()
  @Type(() => GeoJSONLayerMeta)
  public meta: GeoJSONLayerMeta;

  public readonly type = SnLayerType.GeoJSON;
}
